var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKommunication(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlSpace: "preserve",
    width: 566.929,
    height: 377.953,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.001 21.125h387.644v220.129H23.001Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 283.465h425.197V0H0Z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.33333 0 0 -1.33333 0 377.953)",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-60.596 0-76.101 62.977-76.101 62.977S-52.881 41.076.056 41.814c19.075.266 34.108 3.115 45.56 6.645l2.746.881c5.185 1.732 9.576 3.582 13.183 5.35.301.323.668.604 1.136.855 3.144 1.684 6.217 3.524 9.577 5.471 1.807 1.31 2.691 2.133 2.691 2.133S60.596 0 0 0m80.959 78.021c-3.301-7.503-11.14-14.344-22.88-19.783C42.556 51.046 21.952 47.085.062 47.085c-1.945 0-3.874.042-5.796.104v-.013l-.158.019c-19.651.651-37.958 4.507-52.064 11.043-13.275 6.15-21.565 14.093-23.941 22.759-.1-1.593-.159-3.2-.166-4.821C-82.271 31.343-47.158-4.905-1.85-5.832c45.527-.931 82.921 36.067 82.848 81.508a82.98 82.98 0 0 1-.039 2.345",
    style: {
      fill: "#a1c74a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(221.208 70.342)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-10.284 11.023-11.619 25.669-2.79 38.081 8.022 11.408 20.519 18.797 33.011 24.402 47.419 20.105 113.183 20.165 160.705.327 17.645-7.664 40.291-21.919 39.646-43.625-.333-6.951-3.607-13.397-8.104-18.533 4.011 5.429 6.716 11.944 6.611 18.567-.763 20.633-22.764 32.783-39.762 39.706-49.595 19.272-129.164 18.881-175.23-9.339C-4.352 38.09-14.995 19.444 0 0",
    style: {
      fill: "#70bde5",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(111.844 136.522)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-.83-.48L0 0",
    style: {
      fill: "#b22e4c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(146.158 161.036)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h-.004a12.633 12.633 0 0 1-1.687 7.811c-2.702 4.605-8.152 7.065-13.387 6.013A12.717 12.717 0 0 1-25.176-.749l-.062-.001.163-.542c.077-.361 6.223-20.758 9.939-33.078.815-2.705 4.65-2.683 5.434.032C-6.102-21.869-.117-1.044-.006-.022z",
    style: {
      fill: "#175583",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(136.685 156.85)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0a9.563 9.563 0 0 0-9.563-9.563A9.562 9.562 0 0 0-19.126 0a9.562 9.562 0 0 0 9.563 9.563A9.563 9.563 0 0 0 0 0",
    style: {
      fill: "#175583",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(133.608 183.119)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h-.004a12.633 12.633 0 0 1-1.687 7.811c-2.702 4.605-8.152 7.065-13.387 6.013A12.717 12.717 0 0 1-25.176-.749l-.062-.001.163-.542c.077-.361 6.223-20.758 9.939-33.078.815-2.705 4.65-2.683 5.434.032C-6.102-21.869-.117-1.044-.006-.022z",
    style: {
      fill: "#175583",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(331.21 156.85)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0a9.563 9.563 0 0 0-9.563-9.563A9.562 9.562 0 0 0-19.126 0a9.562 9.562 0 0 0 9.563 9.563A9.563 9.563 0 0 0 0 0",
    style: {
      fill: "#175583",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(328.133 183.119)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-43.837 0-79.501-16.155-79.501-36.012S-43.837-72.024 0-72.024s79.5 16.155 79.5 36.012S43.837 0 0 0",
    style: {
      fill: "#a1c74a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(221.326 194.834)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-43.837 0-79.501 16.155-79.501 36.012 0 19.858 35.664 36.012 79.501 36.012S79.5 55.87 79.5 36.012C79.5 16.155 43.837 0 0 0",
    style: {
      fill: "#a1c74a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(221.326 122.81)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c.544 1.975.882 3.259.907 3.487l.006.021H.909a11.901 11.901 0 0 1-.586 5.188c-2.171 6.246-8.994 9.549-15.24 7.378-5.593-1.944-8.813-7.62-7.867-13.27l-.059-.002.154-.51c.035-.166 1.426-4.808 3.248-10.866a74.04 74.04 0 0 0 7.479 3.986C-8.251-2.869-4.241-1.34 0 0",
    style: {
      fill: "#175583",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(175.345 191.347)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0a9.001 9.001 0 0 1 9.001 9.002 9.001 9.001 0 0 1-18.002 0A9.001 9.001 0 0 1 0 0",
    style: {
      fill: "#175583",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(164.36 210.58)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c1.528 5.394 2.648 9.439 2.694 9.862l.005.021h-.003a11.903 11.903 0 0 1-.586 5.188c-2.171 6.246-8.994 9.549-15.24 7.378-5.593-1.944-8.813-7.62-7.867-13.271l-.059-.001.153-.51c.031-.145 1.097-3.707 2.581-8.645 2.96.149 5.951.232 8.97.232C-6.203.254-3.085.162 0 0",
    style: {
      fill: "#175583",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(230.679 197.644)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0a9.001 9.001 0 0 1 9.001 9.002 9.001 9.001 0 0 1-18.002 0A9.001 9.001 0 0 1 0 0",
    style: {
      fill: "#175583",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(221.48 223.251)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c1.821 6.406 3.231 11.461 3.282 11.938l.006.02h-.003a11.907 11.907 0 0 1-.586 5.189c-2.171 6.245-8.994 9.548-15.24 7.377-5.593-1.944-8.813-7.62-7.867-13.27l-.059-.002.154-.51c.013-.066.245-.849.632-2.145 4.409-1.373 8.566-2.954 12.41-4.735A74.506 74.506 0 0 0 0 0",
    style: {
      fill: "#175583",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(286.54 182.897)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0a9.001 9.001 0 0 1 9.001 9.002A9.002 9.002 0 1 1 0 0",
    style: {
      fill: "#175583",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(277.93 210.58)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h-.004a15.057 15.057 0 0 1-1.083 7.457c-3.049 7.269-11.449 11.038-18.905 8.48-7.121-2.443-11.225-9.652-10.024-16.83l-.074-.002.194-.646c.096-.448 8.036-26.793 12.382-41.202.816-2.705 4.651-2.681 5.435.033C-7.87-28.142-.144-1.294-.007-.026z",
    style: {
      fill: "#175583",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(203.424 115.476)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c0-6.297-5.105-11.402-11.402-11.402-6.297 0-11.402 5.105-11.402 11.402 0 6.297 5.105 11.402 11.402 11.402C-5.105 11.402 0 6.297 0 0",
    style: {
      fill: "#175583",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(199.756 146.796)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h-.004a15.067 15.067 0 0 1-1.082 7.457c-3.05 7.269-11.45 11.038-18.906 8.48-7.121-2.443-11.225-9.652-10.024-16.83l-.074-.002.194-.646c.096-.448 8.036-26.793 12.382-41.202.816-2.705 4.651-2.681 5.435.033C-7.87-28.142-.144-1.294-.007-.026z",
    style: {
      fill: "#175583",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(265.778 115.945)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c0-6.297-5.105-11.402-11.402-11.402-6.297 0-11.402 5.105-11.402 11.402 0 6.297 5.105 11.402 11.402 11.402C-5.105 11.402 0 6.297 0 0",
    style: {
      fill: "#175583",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(262.11 147.265)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-10.36-11.484-24.274-19.435-38.35-25.549-60.314-24.405-136.718-24.724-197.444-1.308-21.693 8.979-49.061 25.105-52.164 50.666-1.797 17.726 10.546 32.377 24.315 41.701 6.823 4.692 14.178 8.489 21.755 11.654-8.184-4.164-16.182-8.883-23.256-14.768-22.659-18.36-27.333-42.283-4.878-63.169C-214.131-51.443-55.192-52.058 0 0",
    style: {
      fill: "#70bde5",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(358.084 130.035)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-19.637-26.477-53.13-40.696-83.824-50.084-71.601-20.46-158.477-19.268-228.382 7.277-25.414 10.355-52.28 24.857-65.896 49.778-17.451 34.201 7.396 62.8 36.43 79.045 5.889 3.321 12.307 6.364 18.512 9.006-4.175-2.094-8.573-4.523-12.621-6.87-22.341-13.325-47.818-35.365-43.049-64.143 3.891-21.342 22.03-36.197 39.834-46.798 76.4-43.255 203.973-44.427 284.955-12.802C-33.989-27.475-14.074-16.836 0 0",
    style: {
      fill: "#70bde5",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(410.644 119.359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-78.963 70.247-32.286-23.593-.255-.056-52.991-11.632-17.593 61.9 39.222 38.6-30.246 18.148 1.273 2.124 32.99-19.794-40.456-39.813 16.556-58.247 50.459 11.077 33.479 24.466L.738 2.658l105.365 19.756 50.867 37.087-43.994 17.505.916 2.301 48.164-19.163-54.948-40.062-.274-.051z",
    style: {
      fill: "#175583",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(213.991 30.405)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0a5.901 5.901 0 1 0-11.804 0A5.901 5.901 0 1 0 0 0",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(378.773 88.647)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0a4.044 4.044 0 0 1-4.04-4.04A4.043 4.043 0 0 1 0-8.079 4.043 4.043 0 0 1 4.04-4.04 4.044 4.044 0 0 1 0 0m0-11.804c-4.281 0-7.765 3.484-7.765 7.764C-7.765.241-4.281 3.725 0 3.725S7.765.241 7.765-4.04c0-4.28-3.484-7.764-7.765-7.764",
    style: {
      fill: "#175583",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(372.871 92.686)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0a5.901 5.901 0 1 0-11.804 0A5.901 5.901 0 1 0 0 0",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(333.326 108.561)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0a4.044 4.044 0 0 1-4.04-4.04A4.044 4.044 0 0 1 0-8.08a4.043 4.043 0 0 1 4.039 4.04A4.043 4.043 0 0 1 0 0m0-11.805c-4.281 0-7.765 3.484-7.765 7.765S-4.281 3.725 0 3.725c4.28 0 7.764-3.484 7.764-7.765S4.28-11.805 0-11.805",
    style: {
      fill: "#175583",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(327.425 112.602)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0a5.901 5.901 0 1 0-11.804 0A5.901 5.901 0 1 0 0 0",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(220.262 28.889)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0a4.044 4.044 0 0 1-4.04-4.04A4.043 4.043 0 0 1 0-8.079 4.043 4.043 0 0 1 4.04-4.04 4.044 4.044 0 0 1 0 0m0-11.804c-4.281 0-7.765 3.484-7.765 7.764C-7.765.241-4.281 3.725 0 3.725S7.765.241 7.765-4.04c0-4.28-3.484-7.764-7.765-7.764",
    style: {
      fill: "#175583",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(214.36 32.929)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0a5.901 5.901 0 1 0-11.804 0A5.901 5.901 0 1 0 0 0",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(329.028 49.967)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0a4.044 4.044 0 0 1-4.04-4.039A4.044 4.044 0 0 1 0-8.079a4.043 4.043 0 0 1 4.039 4.04A4.043 4.043 0 0 1 0 0m0-11.804c-4.281 0-7.765 3.484-7.765 7.765 0 4.28 3.484 7.764 7.765 7.764 4.28 0 7.764-3.484 7.764-7.764 0-4.281-3.484-7.765-7.764-7.765",
    style: {
      fill: "#175583",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(323.126 54.007)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0a5.901 5.901 0 1 0-11.804 0A5.901 5.901 0 1 0 0 0",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(140.374 101.294)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0a4.044 4.044 0 0 1-4.04-4.04A4.044 4.044 0 0 1 0-8.08a4.043 4.043 0 0 1 4.039 4.04A4.043 4.043 0 0 1 0 0m0-11.805c-4.281 0-7.765 3.484-7.765 7.765S-4.281 3.725 0 3.725c4.28 0 7.764-3.484 7.764-7.765S4.28-11.805 0-11.805",
    style: {
      fill: "#175583",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(134.473 105.334)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0a5.901 5.901 0 1 0-11.804 0A5.901 5.901 0 1 0 0 0",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(108.757 76.632)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0a4.044 4.044 0 0 1-4.04-4.04A4.044 4.044 0 0 1 0-8.08a4.044 4.044 0 0 1 4.04 4.04A4.044 4.044 0 0 1 0 0m0-11.805c-4.281 0-7.765 3.484-7.765 7.765S-4.281 3.725 0 3.725 7.765.241 7.765-4.04 4.281-11.805 0-11.805",
    style: {
      fill: "#175583",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(102.855 80.672)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0a5.901 5.901 0 1 0-11.804 0A5.901 5.901 0 1 0 0 0",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(58.168 66.514)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0a4.043 4.043 0 0 1-4.039-4.04A4.042 4.042 0 0 1 0-8.079 4.043 4.043 0 0 1 4.04-4.04 4.044 4.044 0 0 1 0 0m0-11.804c-4.28 0-7.764 3.484-7.764 7.764C-7.764.241-4.28 3.725 0 3.725c4.281 0 7.765-3.484 7.765-7.765 0-4.28-3.484-7.764-7.765-7.764",
    style: {
      fill: "#175583",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(52.266 70.554)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0a5.901 5.901 0 1 0-11.804 0A5.901 5.901 0 1 0 0 0",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(36.668 124.691)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0a4.044 4.044 0 0 1-4.04-4.039A4.044 4.044 0 0 1 0-8.079a4.044 4.044 0 0 1 4.04 4.04A4.044 4.044 0 0 1 0 0m0-11.804c-4.281 0-7.765 3.484-7.765 7.765 0 4.28 3.484 7.764 7.765 7.764S7.765.241 7.765-4.039c0-4.281-3.484-7.765-7.765-7.765",
    style: {
      fill: "#175583",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(30.766 128.73)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0a5.901 5.901 0 1 0-11.804 0A5.901 5.901 0 1 0 0 0",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(46.153 182.868)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0a4.044 4.044 0 0 1-4.04-4.04A4.045 4.045 0 0 1 0-8.081 4.045 4.045 0 0 1 4.04-4.04 4.044 4.044 0 0 1 0 0m0-11.804c-4.281 0-7.765 3.483-7.765 7.764C-7.765.241-4.281 3.724 0 3.724S7.765.241 7.765-4.04c0-4.281-3.484-7.764-7.765-7.764",
    style: {
      fill: "#175583",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(40.251 186.908)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-44.897 4.426.242 2.465L.242 2.465Z",
    style: {
      fill: "#175583",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(117.91 160.452)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0a5.901 5.901 0 1 0-11.804 0A5.901 5.901 0 1 0 0 0",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(80.933 167.059)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0a4.043 4.043 0 0 1-4.039-4.04A4.043 4.043 0 0 1 0-8.08a4.044 4.044 0 0 1 4.04 4.04A4.044 4.044 0 0 1 0 0m0-11.804c-4.28 0-7.764 3.483-7.764 7.764C-7.764.241-4.28 3.724 0 3.724c4.281 0 7.765-3.483 7.765-7.764 0-4.281-3.484-7.764-7.765-7.764",
    style: {
      fill: "#175583",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(75.03 171.1)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKommunication);
export default __webpack_public_path__ + "static/media/kommunication.696bd8a409a0c381f16c112ba2a10ad9.svg";
export { ForwardRef as ReactComponent };